import React, { forwardRef } from "react";
import { makeStyles } from "@material-ui/core";
import {
	TAB_HEIGHT,
	QUICK_ADD_HEIGHT,
} from "Components/QuickAdd/QuickAddHelper";
import { CellSize } from "./CalendarHelper";

interface Props {
	cellSize: CellSize;
	children: React.ReactNode;
}

const CalendarRootView = forwardRef<HTMLDivElement, Props>((props, ref) => {
	const classes = useStyles({
		paddingTop:
			props.cellSize.navigation.appHeight +
			props.cellSize.navigation.calendarHeight,
	});

	return (
		<div className={classes.root} ref={ref}>
			{props.children}
		</div>
	);
});

export default CalendarRootView;

interface StyleProps {
	paddingTop: number;
}

const useStyles = makeStyles({
	root: (props: StyleProps) => ({
		display: "flex",
		flexDirection: "column",
		flex: 1,
		paddingTop: props.paddingTop,
		paddingBottom: QUICK_ADD_HEIGHT + TAB_HEIGHT,
	}),
});
